
if ( typeof VideoBackgroundElement !== 'function' ) {

  class VideoBackgroundElement extends HTMLElement {

    static disableM3u8 = true;

    static loadSources(video){
      let sources = Array.from(video.querySelectorAll('source'));
      if ( VideoBackgroundElement.disableM3u8 ) {
        const isStream = elm => ( elm.getAttribute('type') || '' ).toLowerCase().includes('mpegurl') || ( elm.dataset.src || '' ).includes('.m3u8');
        const files = sources.filter(elm => ! isStream(elm));
        if ( files.length > 0 ) {
          sources.filter(isStream).forEach(elm => elm.remove());
          const resolution = elm => {
            const match = ( elm.dataset.src || '' ).match(/-(\d{3,4})p/);
            return match ? parseInt(match[1]) : 0;
          };
          files.sort((a, b) => resolution(b) - resolution(a)).forEach(elm => video.append(elm));
          sources = files;
        }
      }
      sources.forEach(elm=>{
        elm.src = elm.dataset.src;
      });
    }

    constructor(){

      super();

      this._eventSuccess = new Event('success');
      this._eventFail = new Event('fail');
      const video = this.querySelector('video');
      video.addEventListener('error', e=>{
        this.switchFallback();
      })
      video.addEventListener('playing', e=>{
        if ( ! this.classList.contains('loaded') ) {
          this.classList.add('loaded');
          this.dispatchEvent(this._eventSuccess);
        }
      })
      video.addEventListener('stalled', e=>{
        if ( ! this.classList.contains('loaded') ) {
          this.switchFallback();
        }
      })

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        if ( ( entries[0].target.querySelector('video-background-element') && ! entries[0].target.querySelector('video-background-element').classList.contains('loaded') ) || ( entries[0].target.matches('video-background-element') && ! entries[0].target.classList.contains('loaded') ) ) {
          VideoBackgroundElement.loadSources(video);
          video.muted = true;
          video.load();
          video.play().catch(e=>{});
        }
        observer.unobserve(this);
      }

      if ( this.getBoundingClientRect().y < window.innerHeight || this.parentNode.getBoundingClientRect().y < window.innerHeight ) {
        VideoBackgroundElement.loadSources(video);
        video.muted = true;
        video.load();
        video.play().catch(e=>{});
      } else {
        this._selfObserver = new IntersectionObserver(handleIntersection.bind(this), {rootMargin: `0px 0px 400px 0px`});
        this._selfObserver.observe(this);
        this._parentObserver = new IntersectionObserver(handleIntersection.bind(this), {rootMargin: `0px 0px 400px 0px`});
        this._parentObserver.observe(this.parentElement);
      }

    }

    disconnectedCallback(){
      if ( this._selfObserver ) {
        this._selfObserver.disconnect();
      }
      if ( this._parentObserver ) {
        this._parentObserver.disconnect();
      }
    }

    switchFallback(){
      const fallback = this.parentElement.querySelector(`[data-video-background-fallback][data-id="${this.dataset.id}"]`);
      if ( fallback ) {
        fallback.append(fallback.querySelector('template').content.cloneNode(true));
        fallback.querySelector('img').setAttribute('srcset', fallback.querySelector('img').getAttribute('srcset'));
      }
      this.dispatchEvent(this._eventFail);
    }

  }

  if ( typeof customElements.get('video-background-element') == 'undefined' ) {
    customElements.define('video-background-element', VideoBackgroundElement);
  }

}

document.addEventListener('shopify:section:load', e=>{
  if ( e.target.classList.contains('mount-video-background') ) {
    setTimeout(()=>{
      e.target.querySelectorAll('video-background-element').forEach(elm=>{
        const video = elm.querySelector('video');
        const element = customElements.get('video-background-element');
        if ( element && typeof element.loadSources == 'function' ) {
          element.loadSources(video);
        } else {
          video.querySelectorAll('source').forEach(source=>{
            source.src = source.dataset.src;
          })
        }
        video.load();
        video.play().catch(e=>{});
      });
    }, 500);
  }
});